export const cloudSignatureProviders = [
  {
    name: 'Приватбанк - хмарний підпис "SmartID"',
    ksp: 6,
    address: 'https://acsk.privatbank.ua/cloud/api/back/',
    port: '',
    directAccess: true,
    clientIdPrefix: 'IIT_',
    confirmationURL: 'https://www.privat24.ua/rd/kep',
    mobileAppName: 'Приват24'
  },
  {
    name: 'DepositSign - хмарний підпис',
    ksp: 6,
    address: 'https://depositsign.com/api/v1/informjust/sign-server',
    port: '',
    clientIdPrefix: '',
    directAccess: true,
    codeEDRPOU: '43005049'
  },
  {
    name: 'Вчасно - хмарний підпис',
    ksp: 4,
    address: 'https://cs.vchasno.ua/ss/',
    port: '',
    directAccess: false,
    codeEDRPOU: '41231992'
  },
  {
    name: 'Вчасно - хмарний підпис (QR)',
    ksp: 6,
    address: 'https://cs.vchasno.ua/ss/',
    port: '',
    directAccess: false,
    clientIdPrefix: 'vchasno_',
    confirmationURL: 'https://cs.vchasno.ua/rd/',
    mobileAppName: 'Вчасно.КЕП'
  },
  {
    name: 'ТОВ «ЦСК «Україна» - хмарний підпис CloudKey',
    ksp: 6,
    address: 'https://sid.uakey.com.ua/smartid/iit/',
    port: '',
    directAccess: false,
    clientIdPrefix: 'DIIA_2',
    confirmationURL: 'https://sid.uakey.com.ua/kep?hash=rd/kep',
    mobileAppName: 'CloudKey',
    codeEDRPOU: '36865753'
  },
  {
    name: 'ESign - хмарний підпис',
    ksp: 4,
    address: 'https://cabinet.e-life.com.ua/api/EDG/Sign',
    port: '',
    directAccess: false,
    codeEDRPOU: '36049014'
  },
  {
    name: 'АТ «ПУМБ» - хмарний підпис',
    ksp: 6,
    address: 'https://apiext.pumb.ua/hogsmeade/striga/v1',
    port: '',
    directAccess: true,
    clientIdPrefix: 'CHECKBOX_',
    confirmationURL: 'https://www.pumb.ua/qes',
    mobileAppName: 'ПУМБ Online'
  },
  {
    name: 'ДПС - хмарний підпис',
    ksp: 4,
    address: 'https://smart-sign.tax.gov.ua/',
    port: '443',
    directAccess: false,
    clientIdType: 1,
    codeEDRPOU: '43174711'
  },
  {
    name: 'Укргазбанк - хмарний підпис «EcoSign»',
    ksp: 6,
    address: 'https://vtms-api-qca.ukrgasbank.com/iit-signer/api/v1',
    port: '',
    directAccess: false,
    clientIdPrefix: 'UGB_PROD',
    confirmationURL: 'https://cihsm-commiter-qca.ukrgasbank.com',
    mobileAppName: '',
    codeEDRPOU: '23697280'
  },
  {
    name: 'Банк Альянс - хмарний підпис',
    ksp: 6,
    address: 'https://cihsm-api.bankalliance.ua/iit-signer/api/v1',
    port: '',
    directAccess: false,
    clientIdPrefix: 'ALLIANCE_PROD',
    confirmationURL: 'https://cihsm-commiter.bankalliance.ua',
    mobileAppName: '',
    codeEDRPOU: '14360506'
  },
  {
    name: 'КНЕДП органів прокуратури - хмарний підпис',
    ksp: 6,
    address: 'https://cihsm-api.gp.gov.ua/iit-signer/api/v1',
    port: '',
    directAccess: false,
    clientIdPrefix: 'OGP_PROD',
    confirmationURL: 'https://cihsm-commiter.gp.gov.ua',
    mobileAppName: '',
    codeEDRPOU: '00034051'
  },
  {
    name: 'АМО ФІНТЕХ – хмарний підпис AMOKEY',
    ksp: 6,
    address: 'https://sserver.amokey.com',
    port: '443',
    clientIdPrefix: '',
    directAccess: true,
    clientIdType: 1,
    codeEDRPOU: '44669502'
  },
  {
    name: 'Ощадбанк - хмарний підпис',
    ksp: 6,
    address: 'https://cihsm-api.oschadbank.ua/iit-signer/api/v1',
    port: '',
    directAccess: false,
    clientIdPrefix: 'OSCHADBANK_MOBILE_PROD',
    confirmationURL: 'https://smartid.oschadbank.ua/widgetidua',
    mobileAppName: 'BC.C SmartID',
    codeEDRPOU: '00032129'
  },
  {
    name: 'Сервер підпису КНЕДП "Військова частина 2428" ДПСУ',
    ksp: 6,
    address: 'https://smart-sign.dpsu.gov.ua/',
    port: '443',
    clientIdPrefix: '',
    clientIdType: 1,
    directAccess: false,
    codeEDRPOU: '14321469'
  }
]
